
import { Vue, Options, prop } from "vue-class-component";
import ModalV3 from "@/app/ui/components/modal/modal-v3.vue";
import Dialog from "primevue/dialog";
import { formatByCountry, resolveCountry } from "@/app/infrastructures/misc/Utils";

class Props {
  modelValue = prop<boolean>({
    required: true,
    default: false,
    type: Boolean
  });
  sttList = prop<any[]>({
    type: Array as () => any[],
    default: () => []
  });
}

@Options({
  name: "SttDetailModal",
  emits: ["close"],
  components: {
    ModalV3,
    Dialog
  }
})
export default class SttDetailModal extends Vue.with(Props) {
  get visible() {
    return this.modelValue;
  }
  close() {
    this.$emit("close");
  }

  get totalNominal(): number {
    return (this.sttList || []).reduce(
      (sum: number, item: any) => sum + item.nominal,
      0
    );
  }

  get prefixCurrency() {
    return resolveCountry() === "MY" ? "RM" : "Rp";
  }

  formatCurrency(value: number): string {
    return formatByCountry(value, { type: "money", prefix: this.prefixCurrency });
  }
}
